
import {Options, Vue} from 'vue-class-component';
import ModuleAuth from '@/store/auth';
import rules from '@/utils/rules';

@Options({
    name: 'LoginForm',
})
export default class LoginForm extends Vue {
    private email: string = 'test@test.com'; // todo
    private password: string = 'test1234'; // todo
    private valid: boolean = false;

    emailRules = [
        rules.emailRequired,
        rules.emailValid,
    ];
    passwordRules = [
        rules.passwordRequired,
        rules.minimalLengthPassword,
    ];

    async submit() {
        if ((this.$refs.form as any).validate()) {
            await ModuleAuth.signIn({email: this.email, password: this.password});
        }
    }
}
